import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  // Badge,
  Input,
  // Table,
  Spinner,
} from "reactstrap"
import Select from "react-select"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
// import { ReactSearchAutocomplete } from "react-search-autocomplete"
import { isEmpty } from "lodash"
import moment from "moment"
import ButtonSpinner from "../../components/ButtonSpinner"
//Import Styles
import "./styles.scss"
//Data Table packeages
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import Modal from "react-bootstrap/Modal"

//components
// import * as permissionAction from "../../store/cGVybWlzc2lvbg/actions"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import * as leadSourceAction from "../../store/bGVhZFNvdXJjZVN0YXR1cw/actions"
import api from "helpers/Api"
import { toast } from "react-toastify"

const LeadSourceStatus = (props) => {
  const title = "Lead Source Status"
  const { dispatch, searchBarStyle } = props

  useEffect(() => {
    dispatch(leadSourceAction.loadRecordsMetaData())
    // dispatch(permissionAction.loadEmployee())
    dispatch(
      leadSourceAction.loadLeadSourceList({
        page: 1,
        limit: 50,
      })
    )
  }, [])
  const specificDispatch = useDispatch()

  const leadUpdate = useSelector((state) => state.leadSourceStatus)

  const { recordsMetaData = {}, lead_source_details = [] } = leadUpdate

  // const employeeUpdate = useSelector(
  //   (specificstate) => specificstate.permissionrequest
  // )

  // const { employee_list = [] } = employeeUpdate
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
  const [downloadLoading, setDownloadLoading] = useState(false)
  //manage Ec initial state
  const [leadData, setLeadData] = useState({
    company: [],
    branch: [],
    department: [],
    fromDate: "",
    toDate: "",
    leadFromDate: "",
    leadToDate: "",
    leadNo: "",
  })

  //filter table change

  //handle change
  const handleChange = async (e) => {
    setLeadData({ ...leadData, [e.target.name]: e.target.value })
  }

  //dropdown initial state
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [events, setEvents] = useState([])
  const [salesAgent, setSalesAgent] = useState([])
  const [source, setSource] = useState([])
  const [subSource, setSubSource] = useState([])

  //reset functionalities
  // const [resetManager, setResetManager] = useState(false)
  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setEvents([])
    setSalesAgent([])
    setSubSource([])
    setSource([])
    setLeadData({
      fromDate: "",
      toDate: "",
      leadNo: "",
      leadFromDate: "",
      leadToDate: "",
    })
    // setResetManager(true)
    // setTimeout(() => {
    //   setResetManager(false)
    // }, 0)
    dispatch(
      leadSourceAction.loadLeadSourceList({
        page: pageChange ? pageCount : 1,
        limit: 50,
      })
    )
  }

  //button spinner state
  const [btnLoader, setBtnLoader] = useState(false)
  //dropdown options

  // const company =
  //   !isEmpty(companies) && companies.map((company) => company.value)
  // const branch = !isEmpty(branches) && branches.map((branch) => branch.value)

  const branchOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) => branch.companyId === companies.value
    )

  //Searchvalue
  const [searchValueList, setSearchValueList] = useState({})
  console.log(searchValueList, "searchValueList")

  const [pageCount, setPageCount] = useState("")
  const [pageLoad, setPageLoad] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  const searchValue = !isEmpty(searchValueList)
    ? searchValueList
    : {
        page: pageChange ? pageCount : 1,
        limit: 50,
      }
  console.log(searchValue, "searchValue")
  //apply filter submit
  const applyFilter = (e) => {
    e.preventDefault()
    var searchCompany = companies && companies.value ? companies.value : ""
    var searchBranch = branches && branches.value ? branches.value : ""
    var searchEvent = events && events.value ? events.value : ""
    var searchAgent = salesAgent && salesAgent.value ? salesAgent.value : ""
    var searchSource = source && source.value ? source.value : ""
    var searchSubSource = subSource && subSource.value ? subSource.value : ""

    var searchFromDate =
      leadData && leadData.fromDate
        ? moment(leadData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      leadData && leadData.toDate
        ? moment(leadData.toDate).format("YYYY-MM-DD")
        : ""
    var searchLeadFromDate =
      leadData && leadData.leadFromDate
        ? moment(leadData.leadFromDate).format("YYYY-MM-DD")
        : ""
    var searchLeadToDate =
      leadData && leadData.leadToDate
        ? moment(leadData.leadToDate).format("YYYY-MM-DD")
        : ""
    var searchLeadNo = leadData && leadData.leadNo ? leadData.leadNo : ""

    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = 50
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchAgent) {
      searchvalue.employeeId = searchAgent
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchSource) {
      searchvalue.leadSourceId = searchSource
    }
    if (searchSubSource) {
      searchvalue.leadSubSourceId = searchSubSource
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }

    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    if (searchLeadFromDate) {
      searchvalue.fromDate = searchLeadFromDate
    }
    if (searchLeadToDate) {
      searchvalue.toDate = searchLeadToDate
    }
    setSearchValueList(searchvalue)
    console.log(searchvalue, "searchvalue")
    dispatch(leadSourceAction.loadLeadSourceList(searchvalue))
    setBtnLoader(true)
    setDownloadLoading(true)
    setTimeout(() => {
      setBtnLoader(false)
      setDownloadLoading(false)
    }, 2000)
  }

  let slNo = 0
  const leadDataTable =
    !isEmpty(lead_source_details) && lead_source_details.data.length > 0
      ? lead_source_details.data.map((data, index) => {
          slNo = slNo + 1

          const leadDate = data.leadDate
            ? moment(data.leadDate)
                .subtract(5, "hours")
                .subtract(30, "minutes")
                .format(`${dateFormate} hh:mm A`)
            : []
          const eventName =
            !isEmpty(data.eventDetails) && data.eventDetails.length > 0
              ? data.eventDetails.map((data) => data.eventName).join(",")
              : "--"
          const eventDate =
            !isEmpty(data.eventDetails) && data.eventDetails.length > 0
              ? data.eventDetails
                  .map((data) =>
                    moment(data.eventDate).format(`${dateFormate}`)
                  )
                  .join(",")
              : "--"
          const colorCode =
            recordsMetaData &&
            !isEmpty(recordsMetaData) &&
            recordsMetaData.processStatusOptions &&
            recordsMetaData.processStatusOptions.length > 0
              ? recordsMetaData.processStatusOptions.find(
                  (_) => _.processStatusId === data.processStatus
                ).colorCode
              : []
          return {
            _id: data._id,
            sNo: slNo,
            leadNo: data.leadNo,
            branchId: data.branchId,
            routeData: data,
            colorCode: colorCode ? colorCode : "",
            leadNoData: data.leadNo,
            branchName: data.branchName,
            budget: data.budget,
            clientName: data.clientName ? data.clientName : "",
            clientContact: data.clientContact ? data.clientContact : "",
            brideName: data.bride ? data.bride : "--",
            groomName: data.groom ? data.groom : "--",
            companyId: data.companyId,
            companyName: data.companyName,
            processStatus: data.processStatus,
            processStatusName: data.processStatusName,
            leadServiceName: data.leadServiceName,
            leadSourceName: data.leadSourceName,
            leadSubSourceName: data.leadSubSourceName,
            leadType: data.leadType,
            salesUrge: data.salesUrge,
            eventName: eventName,
            eventDate: eventDate,
            overallStatus: !isEmpty(data.overAllStatus)
              ? data.overAllStatus
              : "--",
            allowOrderData: data.isAllowOrder,
            allowOrder: data.isAllowOrder === true ? "YES" : "NO",
            eventDetails: data.events,
            clientCode: !isEmpty(data.clientCode) ? data.clientCode : "",
            leadDate: leadDate,
            salesAgent:data.leadAssign?data.leadAssign:"--",
            key: index,
          }
        })
      : []

  console.log(leadDataTable, "leadDataTable")
  //download feature in data table
  // const { ExportCSVButton } = CSVExport

  //columns for data table
  const initialColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      hidden: false,
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      sort: true,
      hidden: false,
      // formatter: (cellContent, row) => {
      //   const leadData = row.routeData
      //   console.log(row, "row")
      //   return (
      //     <div className={row.processStatus != "PS9" ? "disabled-button" : ""}>
      //       {" "}
      //       <Link
      //         to={{
      //           pathname: `/client-details/${row._id}`,
      //           state: { row: leadData, mode: "EC", menuName: "LeadSourceStatus" },
      //         }}
      //       >
      //         <span>{row.leadNo}</span>
      //       </Link>
      //     </div>
      //   )
      // },
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "110px",
      },
    },

    {
      dataField: "companyName",
      text: "Company",
      sort: true,
      hidden: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch",
      sort: true,
      hidden: false,
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "clientCode",
      text: "Client Code",
      sort: true,
      hidden: false,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "125px",
      },
    },
    {
      dataField: "clientName",
      text: "Client Name ",
      sort: true,
      hidden: false,
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "clientContact",
      text: "Client Contact",
      sort: true,
      hidden: false,
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "brideName",
      text: "Bride Name ",
      sort: true,
      hidden: false,
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "groomName",
      text: "Groom Name ",
      sort: true,
      hidden: false,
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "leadDate",
      text: "Lead Date",
      sort: true,
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "eventName",
      text: "Event Name",
      hidden: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "eventDate",
      text: "Event Date",
      hidden: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "leadSourceName",
      text: "Source",
      hidden: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "leadSubSourceName",
      text: "Sub Source",
      hidden: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "budget",
      text: "Budget",
      hidden: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "overallStatus",
      text: "Overall Status",
      sort: true,
      hidden: false,
      style: {
        fontWeight: 600,
        color: "#e40d8c",
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "salesAgent",
      text: "Sales Agent Name",
      hidden: false,
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "processStatusName",
      text: "Status",
      sort: true,
      hidden: false,
      formatter: (cellContent, row) => {
        console.log(row.colorCode, "colorCode")
        return (
          <button
            style={{
              background: row.colorCode,
              border: "none",
              cursor: "pointer",
              color: "white",
              padding: "4px 6px",
              borderRadius: "4px",
            }}
          >
            {row.processStatusName}
          </button>
        )
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
  ]

  //Columns section
  const [columns, setColumns] = useState(initialColumns)
  const [columnModal, setColumnModal] = useState(false)
  const [oddColumnData, setOddColumnData] = useState([])
  const [evenColumnData, setEvenColumnData] = useState([])
  useEffect(() => {
    if (columns && columns.length > 0) {
      var array = columns
      var evenColumns = []
      var oddColumns = []

      for (var i = 0; i < array.length; i++) {
        if (i % 2 === 0) {
          oddColumns.push(array[i])
        } else {
          evenColumns.push(array[i])
        }
      }

      setOddColumnData(oddColumns)
      setEvenColumnData(evenColumns)
    }
  }, [columns])

  const selectColumn = columns
    .filter((column) => column.hidden === false)
    .map((column) => column.dataField)

  const [selectedColumns, setSelectedColumns] = useState(selectColumn)

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target

    let updatedSelectedColumns
    if (checked) {
      updatedSelectedColumns = [...selectedColumns, value]
    } else {
      updatedSelectedColumns = selectedColumns.filter(
        (column) => column !== value
      )
    }

    setSelectedColumns(updatedSelectedColumns)
  }

  //  "Select All" checkbox
  const handleSelectAllChange = (e) => {
    const { checked } = e.target
    if (checked) {
      const allColumns = columns.map((column) => column.dataField)
      setSelectedColumns(allColumns)
    } else {
      const restoredColumns = initialColumns
        .filter((column) => !column.hidden)
        .map((column) => column.dataField)
      setSelectedColumns(restoredColumns)
    }
  }

  const handleSaveColumns = () => {
    setColumnModal(false)

    const updatedColumns = columns.map((column) => {
      const isColumnSelected = selectedColumns.includes(column.dataField)
      return { ...column, hidden: !isColumnSelected }
    })

    setColumns(updatedColumns)
    // default columns
    const defaultColumns = initialColumns.filter((column) => !column.hidden)
    const selectedNonDefaultColumns = selectedColumns.filter(
      (column) =>
        !defaultColumns.some(
          (defaultColumn) => defaultColumn.dataField === column
        )
    )

    if (selectedNonDefaultColumns.length > 0) {
      toast.success("New Columns added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }
  }

  const handleRestoreToDefault = () => {
    const restoreColumns = initialColumns
      .filter((column) => !column.hidden)
      .map((column) => column.dataField)

    setSelectedColumns(restoreColumns)
  }

  //Pagination section start //
  //Search filter
  const [searchInput, setSearchInput] = useState("")
  const [searchFilter, setSearchFilter] = useState(false)
  console.log(searchInput, "searchInput")

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    specificDispatch(
      leadSourceAction.loadLeadSourceList({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }

  //Download functionality

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    var searchCompany = companies && companies.value ? companies.value : ""
    var searchBranch = branches && branches.value ? branches.value : ""
    var searchEvent = events && events ? events.value : ""
    var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""
    var searchSource = source && source.value ? source.value : ""
    var searchSubSource = subSource && subSource.value ? subSource.value : ""
    var searchFromDate =
      leadData && leadData.fromDate
        ? moment(leadData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      leadData && leadData.toDate
        ? moment(leadData.toDate).format("YYYY-MM-DD")
        : ""
    var searchLeadFromDate =
      leadData && leadData.leadFromDate
        ? moment(leadData.leadFromDate).format("YYYY-MM-DD")
        : ""
    var searchLeadToDate =
      leadData && leadData.leadToDate
        ? moment(leadData.leadToDate).format("YYYY-MM-DD")
        : ""
    var searchLeadNo = leadData && leadData.leadNo ? leadData.leadNo : ""

    var searchvalue = {}

    // searchvalue.page = pageChange ? pageCount : 1
    // searchvalue.limit = 50
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchAgent) {
      searchvalue.employeeId = searchAgent
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchSource) {
      searchvalue.leadSourceId = searchSource
    }
    if (searchSubSource) {
      searchvalue.leadSubSourceId = searchSubSource
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    if (searchLeadFromDate) {
      searchvalue.fromDate = searchLeadFromDate
    }
    if (searchLeadToDate) {
      searchvalue.toDate = searchLeadToDate
    }
    setPageLoad(!pageLoad)

    setDownloadLoading(true)
    api
      .post(`/lead_source_status_report_excel_export`, searchvalue)
      .then((response) => {
        console.log(response.data, "response")

        const unassignedExcelDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
              const leadDate = data.leadDate
                ? moment(data.leadDate)
                    .subtract(5, "hours")
                    .subtract(30, "minutes")
                    .format(`${dateFormate} hh:mm A`)
                : []
              // const eventCount =
              //   !isEmpty(data) && data.events.length > 0
              //     ? data.events.length
              //     : 0

              const groomName = !isEmpty(data.groom)
                ? JSON.stringify(data.groom).replace(/","/g, "\n")
                : "--"
              const brideName = !isEmpty(data.bride)
                ? JSON.stringify(data.bride).replace(/","/g, "\n")
                : "--"
              const eventNameData =
                !isEmpty(data.eventDetails) && data.eventDetails.length > 0
                  ? data.eventDetails.map((data) => data.eventName).join(",")
                  : ""

              const eventName = !isEmpty(eventNameData)
                ? JSON.stringify(eventNameData).replace(/","/g, "\n")
                : "--"
              const eventDateData =
                !isEmpty(data.eventDetails) && data.eventDetails.length > 0
                  ? data.eventDetails
                      .map((data) =>
                        moment(data.eventDate).format(`${dateFormate}`)
                      )
                      .join(",")
                  : ""
              const eventDate = !isEmpty(eventDateData)
                ? JSON.stringify(eventDateData).replace(/","/g, "\n")
                : "--"
              return {
                _id: data._id,
                sNo: index + 1,
                leadNo: data.leadNo,
                branchId: data.branchId,
                routeData: data,
                leadNoData: data.leadNo,
                branchName: data.branchName,
                eventName: eventName,
                groomName: groomName,
                brideName: brideName,
                eventDate: eventDate,
                budget: data.budget,
                clientName: data.clientName ? data.clientName : "",
                clientContact: data.clientContact ? data.clientContact : "",
                companyId: data.companyId,
                companyName: data.companyName,
                leadServiceName: data.leadServiceName,
                leadSourceName: data.leadSourceName,
                leadSubSourceName: data.leadSubSourceName,
                leadType: data.leadType,
                salesUrge: data.salesUrge,
                processStatus: data.processStatus,
                processStatusName: data.processStatusName,
                overallStatus: !isEmpty(data.overAllStatus)
                  ? data.overAllStatus
                  : "--",
                allowOrderData: data.isAllowOrder,
                allowOrder: data.isAllowOrder === true ? "YES" : "NO",
                eventDetails: data.events,
                clientCode: !isEmpty(data.clientCode) ? data.clientCode : "",
                leadDate: leadDate,
                salesAgent:data.leadAssign?data.leadAssign:"--",
                key: index,
              }
              // }
            })
          : []
        setTimeout(() => {
          let headerData = [
            "S.No,Lead No,Company,Branch,Client Code,Client Name,Client Contact,Bride Name,Groom Name, Lead Date,Event Date, Event Name, Source, Sub Source,Budget, Overall Status,Sales Agent Name, Status",
          ]

          let usersCsv = !isEmpty(unassignedExcelDataTable)
            ? unassignedExcelDataTable.reduce((acc, user) => {
                const {
                  sNo,
                  leadNo,
                  companyName,
                  branchName,
                  clientCode,
                  clientName,
                  clientContact,
                  brideName,
                  groomName,
                  leadDate,
                  eventDate,
                  eventName,
                  leadSourceName,
                  leadSubSourceName,
                  budget,
                  overallStatus,
                  salesAgent,
                  processStatusName,
                } = user
                acc.push([
                  sNo,
                  leadNo,
                  companyName,
                  branchName,
                  clientCode,
                  clientName,
                  clientContact,
                  brideName,
                  groomName,
                  leadDate,
                  eventDate,
                  eventName,
                  leadSourceName,
                  leadSubSourceName,
                  budget,
                  overallStatus,
                  salesAgent,
                  processStatusName,
                ])

                console.log("test", acc)
                return acc
              }, [])
            : false
          console.log(usersCsv, "usersCsv")

          const usersList =
            !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : []

          downloadFile({
            data: [...headerData, ...usersList].join("\n"),
            fileName: "LeadSourceReport.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 2500)
        return response.data
      })
      .catch((error) => Promise.reject(error))
  }

  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>

                      <Col md="8">
                        <div
                          style={{
                            marginBottom: "20px",
                            marginTop: "-40px",
                            marginRight: "10px",
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-info"
                            onClick={() => setColumnModal(true)}
                          >
                            Edit Columns
                          </Button>
                        </div>
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                              marginBottom: "20px",
                              marginTop: "-41px",
                              marginRight: "10px",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col id="my-component">
                        <BootstrapTable
                          remote
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                          // expandRow={expandRow}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )

  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: lead_source_details.length,
    data:
      !isEmpty(lead_source_details) && lead_source_details.length > 0
        ? lead_source_details.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (type, { page, currentIndex, sizePerPage }) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    console.log(page, "page")
    let result =
      !isEmpty(lead_source_details.data) && lead_source_details.data.length > 0
        ? lead_source_details.data
        : []

    var searchCompany = companies && companies.value ? companies.value : ""
    var searchBranch = branches && branches.value ? branches.value : ""
    var searchEvent = events && events ? events.value : ""
    var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""
    var searchSource = source && source.value ? source.value : ""
    var searchSubSource = subSource && subSource.value ? subSource.value : ""

    var searchFromDate =
      leadData && leadData.fromDate
        ? moment(leadData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      leadData && leadData.toDate
        ? moment(leadData.toDate).format("YYYY-MM-DD")
        : ""
    var searchLeadFromDate =
      leadData && leadData.leadFromDate
        ? moment(leadData.leadFromDate).format("YYYY-MM-DD")
        : ""
    var searchLeadToDate =
      leadData && leadData.leadToDate
        ? moment(leadData.leadToDate).format("YYYY-MM-DD")
        : ""
    var searchLeadNo = leadData && leadData.leadNo ? leadData.leadNo : ""

    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = 50
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchAgent) {
      searchvalue.employeeId = searchAgent
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchSource) {
      searchvalue.leadSourceId = searchSource
    }
    if (searchSubSource) {
      searchvalue.leadSubSourceId = searchSubSource
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    if (searchLeadFromDate) {
      searchvalue.fromDate = searchLeadFromDate
    }
    if (searchLeadToDate) {
      searchvalue.toDate = searchLeadToDate
    }

    specificDispatch(leadSourceAction.loadLeadSourceList(searchvalue))

    setPageLoad(!pageLoad)

    setDownloadLoading(true)
    setTimeout(() => {
      setDownloadLoading(false)
    }, 1400)

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Event Coordination"} breadcrumbItem={title} />

          {/*form start */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="companies"
                          // isMulti
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                          zIndex="2"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branches"
                          // isMulti
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Event"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="events"
                          value={events}
                          // isMulti
                          onChange={(e) => setEvents(e)}
                          options={
                            recordsMetaData ? recordsMetaData.eventOptions : []
                          }
                          placeholder="Select event"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Source"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="source"
                          value={source}
                          // isMulti
                          onChange={(e) => setSource(e)}
                          options={
                            recordsMetaData ? recordsMetaData.sourceOptions : []
                          }
                          placeholder="Select Source"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Sub Source"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="subSource"
                          value={subSource}
                          // isMulti
                          onChange={(e) => setSubSource(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.subSourceOptions
                              : []
                          }
                          placeholder="Select Sub Source"
                          classNamePrefix="select2-selection"
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"Lead From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="leadFromDate"
                          value={leadData.leadFromDate}
                          max={leadData.leadToDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Lead To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="leadToDate"
                          value={leadData.leadToDate}
                          min={leadData.leadFromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"Event From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={leadData.fromDate}
                          max={leadData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Event To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={leadData.toDate}
                          min={leadData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => applyFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBarStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <button
                          className="btn btn-success mx-2"
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#ffffff" : "",
                          }}
                          // onClick={(e) => handleClick()}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>{" "}
                  {/* <div className="d-flex flex-row">
                    
                    
                  </div> */}
                  <RemotePagination
                    data={leadDataTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={
                      !isEmpty(lead_source_details)
                        ? lead_source_details.totalDataCount
                        : 0
                    }
                    onTableChange={handleTableChange}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {columnModal && (
        <Modal size="xl" show={columnModal}>
          <Modal.Header
            style={{
              backgroundColor: "white",
              color: "black",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Edit Columns
            <span>
              <i
                className="fa fa-times quote-close"
                aria-hidden="true"
                onClick={() => setColumnModal(false)}
              ></i>
            </span>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <div>
                <Input
                  type="checkbox"
                  checked={selectedColumns.length === columns.length}
                  onChange={(e) => handleSelectAllChange(e)}
                  style={{ width: "15px", height: "15px" }}
                />
                <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                  Select All
                </Label>
              </div>
            </Row>
            <Row>
              <Col sm="12" md="6" lg="6" className="ml-4">
                {oddColumnData.map((column) => (
                  <div key={column.dataField} className="d-flex flex-row">
                    <div className="form-check form-check-inline">
                      <Input
                        type="checkbox"
                        value={column.dataField}
                        checked={selectedColumns.includes(column.dataField)}
                        onChange={(e) => handleCheckboxChange(e)}
                        style={{ width: "15px", height: "15px" }}
                      />
                      <Label
                        style={{
                          fontSize: "16px",
                          marginLeft: "10px",
                        }}
                      >
                        {column.text}
                      </Label>
                    </div>
                  </div>
                ))}
              </Col>
              <Col sm="12" md="6" lg="6">
                {evenColumnData.map((column) => (
                  <div key={column.dataField} className="d-flex flex-row">
                    <div className="form-check form-check-inline">
                      <Input
                        type="checkbox"
                        value={column.dataField}
                        checked={selectedColumns.includes(column.dataField)}
                        onChange={(e) => handleCheckboxChange(e)}
                        style={{ width: "15px", height: "15px" }}
                      />
                      <Label
                        style={{
                          fontSize: "16px",
                          marginLeft: "10px",
                        }}
                      >
                        {column.text}
                      </Label>
                    </div>
                  </div>
                ))}
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <p
              className="text-decoration-underline text-info"
              style={{ cursor: "pointer", fontSize: "16px" }}
              onClick={handleRestoreToDefault}
            >
              Restore To Default
            </p>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => {
                setColumnModal(false)
                setSelectedColumns(selectColumn)
              }}
            >
              Close
            </Button>
            <Button
              variant="primary"
              className="btn btn-success"
              onClick={() => handleSaveColumns()}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {downloadLoading ? (
        <Modal
          show={downloadLoading}
          style={{ width: "6.7%", margin: "18% 50%" }}
        >
          <Modal.Body>
            <Spinner
              as="span"
              animation="grow"
              size="lg"
              role="status"
              aria-hidden="true"
              variant="success"
              className="mx-2"
              color="success"
            />
            {/* <span>Loading...</span> */}
          </Modal.Body>
        </Modal>
      ) : (
        ""
      )}
    </React.Fragment>
  )
}

LeadSourceStatus.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LeadSourceStatus)
)
